import Big from 'big.js';
import md5 from 'js-md5'
//npm install js-md5

import _ from "lodash";
import {
    BsyUtils
} from '../utils/Utils'
import {
    BsyFormulaCalcParser
} from './FormulaCalcParser'
import { customError } from '../utils/rowExecuteRely_3_0';
import { dayjsUtils } from '../utils/dayjsUtils';


export const BsyFormula = {
    AND: function () {
        for (let a = BsyUtils.flatten(arguments), b = 0, c = a.length; b < c; b++)
            if (!a[b])
                return !1;
        return !0
    },
    OR: function () {
        for (let a = BsyUtils.flatten(arguments), b = 0, c = a.length; b < c; b++)
            if (a[b])
                return !0;
        return !1
    },
    FALSE: function () {
        return !1
    },
    TRUE: function () {
        return !0
    },
    IF: function (a, b, c) {
        return a ? b : c
    },
    NOT: function (a) {
        return !a
    },
    XOR: function () {
        for (var a = 0, b = BsyUtils.flatten(arguments), c = 0, d = b.length; c < d; c++)
            b[c] && a++;
        return !!(1 & Math.floor(Math.abs(a)))
    },
    CHAR: function (t) {
        return 9 === t || 10 === t || 34 === t || 39 === t || 92 === t ? String.fromCharCode(t) : ""
    },
    CONCATENATE: function () {
        for (var a = BsyUtils.flatten(arguments), b = 0;
            (b = a.indexOf(!0)) > -1;)
            a[b] = "TRUE";
        for (var c = 0;
            (c = a.indexOf(!1)) > -1;)
            a[c] = "FALSE";
        return a.join("")
    },
    EXACT: function (a, b) {
        return a === b
    },
    LEFT: function (a, b) {
        b = BsyUtils.isEmpty(b) ? 1 : b
        return a ? a.substring(0, b) : ""
    },
    LEN: function (a) {
        return BsyUtils.isString(a) ? a ? a.length : 0 : a && a.length ? a.length : 0
    },
    LOWER: function (a) {
        return BsyUtils.isString(a) ? a ? a.toLowerCase() : a : ""
    },
    REPLACE: function (a, b, c, d) {
        if (BsyUtils.isNumber(b) && BsyUtils.isNumber(c)) {
            a = a || ""
            d = d || ""
            return a.substr(0, b - 1) + d + a.substr(b - 1 + c)
        } else {
            return a.replace(new RegExp(b, 'g'), c);
        }

        // return BsyUtils.isNumber(b) && BsyUtils.isNumber(c) ? (a = a || "",
        // d = d || "",
        // a.substr(0, b - 1) + d + a.substr(b - 1 + c)) : (a.replace( new RegExp(b,'g') ,c))
    },
    REPT: function (a, b) {
        b = b || 0;
        return new Array(b + 1).join(a)
    },
    RIGHT: function (a, b) {
        b = void 0 === b ? 1 : b;
        return a ? a.substring(a.length - b) : ""
    },
    SEARCH: function (a, b, c) {

        if (BsyUtils.isString(a) && BsyUtils.isString(b)) {
            c = BsyUtils.isNull(c) ? 0 : c
            return b.toLowerCase().indexOf(a.toLowerCase(), c - 1) + 1
        } else {
            return 0;
        }

    },
    SPLIT: function (a, b) {
        return BsyUtils.isString(a) ? a.split(b) : []
    },
    TRIM: function (a) {
        return BsyUtils.isString(a) ? a.replace(/ +/g, " ").trim() : ""
    },
    UPPER: function (a) {
        return BsyUtils.isString(a) ? a.toUpperCase() : ""
    },
    RMBCAP: function (e) {
        var t, r, n = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"], a = ["", "拾", "佰", "仟", "万", "亿"], o = ["角", "分"], i = "人民币", c = BsyUtils.parseNumber(e);
        if (_.isNil(c))
            return "";
        if (c >= 1e16)
            return "";
        if (0 === c)
            return i += n[0] + "元整";

        if (c < 0) {
            i += "负";
            c = Math.abs(c);
        }

        // c < 0 && (i += "负",
        // c = Math.abs(c));


        var l = c.toString();
        if (l.indexOf(".") < 0) {
            t = l;
            r = ""
        } else {
            var u = l.split(".");
            t = u[0];
            r = u[1].substr(0, 2)
        }
        if (Number(t) > 0 && (i += function e(t) {
            var r = "";
            if (1 === t.length)
                return n[Number(t)];
            if (t.length <= 5)
                for (var o = 0, i = t.length; i--; o++)
                    r += e(t[o]) + (Number(t[o]) && i ? a[i] : "");
            else {
                for (var c = t.length / 4 >> 0, l = t.length % 4; 0 === l || !a[3 + c];) {
                    l += 4;
                    c--;
                }

                if (Number(t.substr(0, l))) {
                    r = e(t.substr(0, l)) + a[3 + c];
                    var u = t.substr(l);
                    "0" === u[0] && (r += n[0]);
                    r += e(u);
                } else
                    r = e(t.substr(0, l)) + e(t.substr(l))
            }
            var s = new RegExp(n[0] + "+", "g")
                , d = new RegExp(n[0] + "*$");
            return r.replace(s, n[0]).replace(d, "")
        }(t),
            i += "元"),
            "" !== r)
            for (var s = r.length, d = 0; d < s; d++) {
                var f = r.substr(d, 1);
                "0" !== f && (i += n[Number(f)] + o[d])
            }
        return "" === i ? i += n[0] + "元整" : r.length <= 1 && (i += "整"),
            i
    },
    MID: function (a, b, c) {
        a = a || ""
        return BsyUtils.isNumber(b) && BsyUtils.isNumber(c) ? a.substr(b - 1, c) : a
    },
    AVERAGE: function () {
        for (var a = BsyUtils.flatten(arguments, function (a) {
            return BsyUtils.isNumber(a)
        }), b = a.length, c = 0, d = 0, e = 0; e < b; e++) {
            c += a[e];
            d += 1;
        }
        return c / d
    },
    COUNT: function () {
        return BsyUtils.flatten(arguments).length
    },
    COUNTIF: function () {
        var len = arguments.length,
            criteria = arguments[len - 1];
        /[<>=!]/.test(criteria) || (criteria = '=="' + criteria + '"');
        for (var args = BsyUtils.flatten(Array.prototype.slice.call(arguments, 0, len - 1)), matches = 0, i = 0; i < args.length; i++) {
            if ("string" != typeof args[i]) {
                // eslint-disable-next-line no-eval
                eval(args[i] + criteria) && matches++
            } else {
                // eslint-disable-next-line no-eval
                eval('"' + args[i] + '"' + criteria) && matches++
            }


            // "string" != typeof args[i] ? eval(args[i] + criteria) && matches++ : eval('"' + args[i] + '"' + criteria) && matches++;
        }

        return matches
    },
    LARGE: function (a, b) {
        a = BsyUtils.flatten(a, function (a) {
            return BsyUtils.isNumber(a)
        })
        return a.sort(function (a, b) {
            return b - a
        })[b - 1]
    },
    MAX: function () {
        var a = BsyUtils.flatten(arguments, function (a) {
            return BsyUtils.isNumber(a)
        });
        return 0 === a.length ? 0 : Math.max.apply(Math, a)
    },
    MIN: function () {
        var a = BsyUtils.flatten(arguments, function (a) {
            return BsyUtils.isNumber(a)
        });
        return 0 === a.length ? 0 : Math.min.apply(Math, a)
    },
    SMALL: function (a, b) {
        a = BsyUtils.flatten(a, function (a) {
            return BsyUtils.isNumber(a)
        })
        return a.sort(function (a, b) {
            return a - b
        })[b - 1]
    },
    ABS: function (a) {
        return BsyUtils.isNumber(a) ? Math.abs(a) : 0
    },
    ROUND: function (t, e) {
        t = BsyUtils.parseNumber(t)
        e = BsyUtils.parseNumber(e)
        if (BsyUtils.isNull(t) || BsyUtils.isNull(e))
            return null;
        var i = BsyFormulaCalcParser.evalExpression("*", t, Math.pow(10, e));
        return Number(new Big(i).round(0).toString()) / Math.pow(10, e)
    },
    parseNumber: function (t) {
        var e = parseFloat(t);
        return !isNaN(e) && isFinite(e) ? e : null
    },
    CEILING: function (a, b) {
        if (0 === b)
            return 0;
        var c = b < 0 ? -1 : 0;
        b = Math.abs(b);
        var d = b - Math.floor(b),
            e = 0;
        d > 0 && (e = -Math.floor(Math.log(d) / Math.log(10)));
        return a >= 0 ? BsyFormula.ROUND(Math.ceil(a / b) * b, e) : 0 === c ? -BsyFormula.ROUND(Math.floor(Math.abs(a) / b) * b, e) : -BsyFormula.ROUND(Math.ceil(Math.abs(a) / b) * b, e)
    },

    FLOOR: function (t, r) {

        if (t = BsyUtils.parseNumber(t),
            r = BsyUtils.parseNumber(r),
            _.isNil(t) || _.isNil(r))
            return null;
        if (0 === r)
            return 0;
        if (!(t > 0 && r > 0 || t < 0 && r < 0))
            return 0;
        r = Math.abs(r);
        var n = BsyFormulaCalcParser.evalExpression("-", r, Math.floor(r))
            , o = 0;
        return n > 0 && (o = -Math.floor(BsyFormulaCalcParser.evalExpression("/", Math.log(n), Math.log(10)))),
            t >= 0 ? BsyFormula.ROUND(BsyFormulaCalcParser.evalExpression("*", Math.floor(BsyFormulaCalcParser.evalExpression("/", t, r)), r), o) : -BsyFormula.ROUND(BsyFormulaCalcParser.evalExpression("*", Math.floor(BsyFormulaCalcParser.evalExpression("/", Math.abs(t), r)), r), o)
        // if (0 === b)
        //     return 0;
        // if (!((a > 0 && b > 0) || (a < 0 && b < 0)))
        //     return 0;
        // b = Math.abs(b);
        // var c = b - Math.floor(b),
        //     d = 0;
        // c > 0 && (d = -Math.floor(Math.log(c) / Math.log(10)))
        // return a >= 0 ? BsyFormula.ROUND(Math.floor(a / b) * b, d) : -BsyFormula.ROUND(Math.floor(Math.abs(a) / b) * b, d)
    },
    INT: function (a) {
        return BsyUtils.isNumber(a) ? Math.floor(a) : 0
    },
    LOG: function (a, b) {
        b = void 0 === b ? 10 : b
        return BsyUtils.isNumber(b) ? Math.log(a) / Math.log(b) : 0
    },
    MOD: function (a, b) {
        if (0 === b)
            return 0;
        var c = Math.abs(a % b);
        return b > 0 ? c : -c
    },
    POWER: function (a, b) {
        var c = Math.pow(a, b);
        return isNaN(c) ? 0 : c
    },
    PRODUCT: function () {
        var a = BsyUtils.flatten(arguments, function (a) {
            return BsyUtils.isNumber(a)
        })
        if (a.length == 0) {
            return 0
        }
        for (var b = 1, c = 0; c < a.length; c++)
            b = BsyFormulaCalcParser.evalExpression("*", b, BsyUtils.parseNumber(a[c]));
        // b *= a[c];
        return b
    },
    SQRT: function (a) {
        return a < 0 ? 0 : Math.sqrt(a)
    },
    SUM: function () {
        for (var a = 0, b = BsyUtils.flatten(arguments, function (a) {
            return BsyUtils.isNumber(a)
        }), c = 0, d = b.length; c < d; ++c)
            a = BsyFormulaCalcParser.evalExpression("+", a, BsyUtils.parseNumber(b[c]));
        // a += b[c];
        return a
    },
    MATH_SUMPRODUCT: function () {
        for (var a = 0, b = [], c = -1, d = 0; d < arguments.length; d++) {

            if (arguments[d] instanceof Array) {
                c = c < 0 ? arguments[d].length : Math.min(arguments[d].length, c)
                b.push(arguments[d])
            }

            // arguments[d]instanceof Array && (c = c < 0 ? arguments[d].length : Math.min(arguments[d].length, c),
            // b.push(arguments[d]));
        }

        for (var e, f, g, h = 0; h < c; h++) {
            for (e = 1, f = 0; f < b.length; f++) {
                g = parseFloat(b[f][h]);
                isNaN(g) && (g = 0);
                e = BsyFormulaCalcParser.evalExpression("*", e, BsyUtils.parseNumber(g));
            }

            // e *= g;
            a = BsyFormulaCalcParser.evalExpression("+", a, BsyUtils.parseNumber(e));
            // a += e
        }
        return a
    },
    SUMPRODUCT: function () {
        for (var a = 0, b = [], c = -1, d = 0; d < arguments.length; d++) {

            if (arguments[d] instanceof Array) {
                c = c < 0 ? arguments[d].length : Math.min(arguments[d].length, c)
                b.push(arguments[d])
            }

            // arguments[d]instanceof Array && (c = c < 0 ? arguments[d].length : Math.min(arguments[d].length, c),
            // b.push(arguments[d]));
        }

        for (var e, f, g, h = 0; h < c; h++) {
            for (e = 1, f = 0; f < b.length; f++) {
                g = parseFloat(b[f][h]);
                isNaN(g) && (g = 0);
                e = BsyFormulaCalcParser.evalExpression("*", e, BsyUtils.parseNumber(g));
            }

            // e *= g;
            a = BsyFormulaCalcParser.evalExpression("+", a, BsyUtils.parseNumber(e));
            // a += e
        }
        return a
    },
    FIXED: function (a, b) {
        b = BsyUtils.parseNumber(b) || 0;

        return b = void 0 === b ? 0 : b,
            BsyUtils.isNumber(b) && b >= 0 ? Number(a).toFixed(b) : ""
    },
    RAND: function () {
        return BsyUtils.fixDecimalPrecision(Math.random(), 6)
    },
    IP: function () {
        return window.FX.STATIC.ip || ""
    },
    SUBFORMLESS: function (a, b) {
        if (!BsyUtils.isArray(a))
            return false;
        if (!BsyUtils.isArray(b))
            return false;
        var result = true;
        BsyUtils.forEach(a, function (i, d) {
            if (a[i] >= b[i])
                result = false;
        });
        return result;
    },
    SUBFORMGREATER: function (a, b) {
        if (!BsyUtils.isArray(a))
            return false;
        if (!BsyUtils.isArray(b))
            return false;

        var result = true;
        BsyUtils.forEach(a, function (i, d) {
            if (a[i] <= b[i])
                result = false;
        });
        return result;
    },
    SUBFORMEQUAL: function (a, b) {
        if (!BsyUtils.isArray(a))
            return false;
        if (!BsyUtils.isArray(b))
            return false;

        var result = true;
        BsyUtils.forEach(a, function (i, d) {
            if (a[i] !== b[i])
                result = false;
        });
        return result;
    },
    SUBFORMGREATEROREQUAL: function (a, b) {
        if (!BsyUtils.isArray(a))
            return false;
        if (!BsyUtils.isArray(b))
            return false;

        var result = true;
        BsyUtils.forEach(a, function (i, d) {
            if (a[i] < b[i])
                result = false;
        });
        return result;
    },
    SUBFORMLESSOREQUAL: function (a, b) {
        if (!BsyUtils.isArray(a))
            return false;
        if (!BsyUtils.isArray(b))
            return false;

        var result = true;
        BsyUtils.forEach(a, function (i, d) {
            if (a[i] > b[i])
                result = false;
        });
        return result;
    },
    SUBFORMNOTEQUAL: function (a, b) {
        if (!BsyUtils.isArray(a))
            return false;
        if (!BsyUtils.isArray(b))
            return false;

        var result = true;
        BsyUtils.forEach(a, function (i, d) {
            if (a[i] === b[i])
                result = false;
        });
        return result;
    },
    DATE: function () {
        if (6 === arguments.length) {
            return new Date(parseInt(arguments[0], 10), parseInt(arguments[1], 10) - 1, parseInt(arguments[2], 10), parseInt(arguments[3], 10), parseInt(arguments[4], 10), parseInt(arguments[5], 10))
        } else if (3 === arguments.length) {
            return new Date(parseInt(arguments[0], 10), parseInt(arguments[1], 10) - 1, parseInt(arguments[2], 10))
        } else if (1 === arguments.length) {
          return BsyUtils.parseDate(arguments[0])
        } else if (0 === arguments.length) {
            return new Date();
        } else {
            return new Date(0);
        }
    },
    TIME: function (a, b, c) {
        return (3600 * a + 60 * b + c) / 86400
    },
    TIMESTAMP: function (a) {
        return BsyUtils.isDate(a) ? a.getTime() : 0
    },
    TODAY: function () {
        var ret = new Date();
        ret.setMilliseconds(0)
        return ret
    },
    NOW: function () {
        var ret = new Date();
        ret.setMilliseconds(0)
        return ret;
    },
    SYSTIME: function () {
        var t = window.FX.STATIC._st,
            e = (new Date).getTime() - window.FX.STATIC._ct;
         0 < e && (t += e);
         return new Date(t)
    },
    DAY: function (a) {
        var b = dayjsUtils.timeToTZ(a);
        if (!BsyUtils.isNull(b))
            return b.getDate()
    },
    MONTH: function (a) {
        var b = dayjsUtils.timeToTZ(a);
        if (!BsyUtils.isNull(b))
            return b.getMonth() + 1
    },
    YEAR: function (a) {
        var b = dayjsUtils.timeToTZ(a);
        if (!BsyUtils.isNull(b))
            return b.getFullYear()
    },
    HOUR: function (a) {
        var b = dayjsUtils.timeToTZ(a);
        if (!BsyUtils.isNull(b))
            return b.getHours()
    },
    MINUTE: function (a) {
        var b = dayjsUtils.timeToTZ(a);
        if (!BsyUtils.isNull(b))
            return b.getMinutes()
    },
    SECOND: function (a) {
        var b = dayjsUtils.timeToTZ(a);
        if (!BsyUtils.isNull(b))
            return b.getSeconds()
    },
    DAYS: function (a, b) {
        var c = dayjsUtils.timeToTZ(a);
        if (!BsyUtils.isNull(c)) {
            var d = dayjsUtils.timeToTZ(b);
            if (!BsyUtils.isNull(d))
                return (new Date(c.getFullYear(), c.getMonth(), c.getDate(), 0, 0, 0, 0).getTime() -
                    new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0).getTime()) / 864e5
        }
    },
    EDATE: function (start_date, months) {

        var a = BsyUtils.parseDate(start_date);
        // console.log('进入 '+a.getFullYear()+'-'+ (a.getMonth()+1) +'-'+a.getDate())
        months = parseInt(months) //与excel逻辑一样 只支持整数
        if (!BsyUtils.isNull(a)) {
            if (months === 0)
                return a.getTime();
            var add = months > 0 ? true : false;
            var addYear = parseInt(Math.abs(months) / 12);
            var addMomth = Math.abs(months) % 12;
            var month = a.getMonth() + 1;
            var day = a.getDate();

            if (add) {

                if (month + addMomth > 12) {
                    let dd = (month + addMomth) / 12;
                    addYear += dd;
                    month = (month + addMomth) % 12;
                } else {
                    month = (month + addMomth)
                }
            } else {

                if (month - addMomth < 0) {
                    addYear += 1;
                    month = 12 + (month - addMomth)
                } else {
                    month = month - addMomth
                }
            }

            if (add) {
                a.setFullYear(a.getFullYear() + addYear)
            } else {
                a.setFullYear(a.getFullYear() - addYear)
            }

            var year = a.getFullYear();
            var mm = 28;
            if (year % 100 != 0 && year % 4 == 0 || year % 400 == 0) {
                mm = 29;
            }
            switch (day) {
                case 29:
                case 30: {
                    switch (month) {
                        case 2: {
                            a.setDate(mm)
                            break;
                        }
                        default: {
                            a.setDate(day)
                            break;
                        }
                    }
                    break;
                }
                case 31: {
                    switch (month) {
                        case 2: {
                            a.setDate(mm)
                            break;
                        }
                        case 4:
                        case 6:
                        case 9:
                        case 11: {
                            a.setDate(30)
                            break;
                        }
                        default: {
                            a.setDate(day)
                            break;
                        }
                    }
                    break;
                }
                default: {
                    a.setDate(day)
                    break;
                }
            }
            a.setMonth(month - 1)

            // console.log('结果 '+a.getFullYear()+'-'+ (a.getMonth()+1) +'-'+a.getDate())
            return a.getTime();
        }
    },
    DATEDIFF: function (t, e, i) {
        var a = dayjsUtils.timeToTZ(e);
        if (!BsyUtils.isNull(a)) {
            var n, s = dayjsUtils.timeToTZ(t);
            if (!BsyUtils.isNull(s)) {
                switch (i) {
                    case "y":
                        n = (e - t) / 31536e6;
                        break;  
                    case "M":
                        n = (e - t) / 2592e6;
                        break;
                    case "d":
                        n = (e - t) / 864e5;
                        break;
                    case "h":
                        n = (e - t) / 36e5;
                        break;
                    case "m":
                        n = (e - t) / 6e4;
                        break;
                    case "s":
                        n = (e - t) / 1e3;
                        break;
                    case "ms":
                        n = (e - t);
                        break;
                    default:
                        n = (e - t) / 864e5
                }
                return BsyUtils.fixDecimalPrecision(n)
            }
        }
    },
    MD5: function (a) {
        return md5(a);
    },
    DAYS360: function (a, b, c) {
        var a = dayjsUtils.timeToTZ(a);
        if (!BsyUtils.isNull(a)) {
            var b = dayjsUtils.timeToTZ(b);
            if (!BsyUtils.isNull(b)) {
                var d, e, f = b.getMonth(),
                    g = a.getMonth();
                if (c) {
                    d = 31 === b.getDate() ? 30 : b.getDate();
                    e = 31 === a.getDate() ? 30 : a.getDate();
                } else {
                    var h = new Date(b.getFullYear(), f + 1, 0).getDate(),
                        i = new Date(a.getFullYear(), g + 1, 0).getDate();
                    d = b.getDate() === h ? 30 : b.getDate()

                    if (a.getDate() === i) {
                        if (d < 30) {
                            g++;
                            e = 1
                        } else {
                            e = 30
                        }
                    } else {
                        e = a.getDate()
                    }


                    // a.getDate() === i ? d < 30 ? (g++, e = 1) : e = 30 : e = a.getDate()
                }
                return 360 * (a.getFullYear() - b.getFullYear()) + 30 * (g - f) + (e - d)
            }
        }
    },
    DATEDELTA: function (a, b) {
        var c = BsyUtils.parseDate(a);
        if (!BsyUtils.isNull(c)) {
            BsyUtils.isNumber(b) || (b = 0)
        }
        return new Date(c.getTime() + 864e5 * b)
    },
    ISOWEEKNUM: function (a) {
        var c = dayjsUtils.timeToTZ(a);
        if (!BsyUtils.isNull(c)) {
            c.setHours(0, 0, 0)
            c.setDate(c.getDate() + 4 - (c.getDay() || 7));
            var b = new Date(c.getFullYear(), 0, 1);
            return Math.ceil(((c - b) / 864e5 + 1) / 7)
        }
    },
    WEEKNUM: function (a, b) {
        var c1 = dayjsUtils.timeToTZ(a);
        if (!BsyUtils.isNull(c1)) {
            var c = 2 === b ? 1 : 0,
                d = new Date(c1.getFullYear(), 0, 1),
                e = (c + 7 - d.getDay()) % 7,
                f = e > 0 ? 1 : 0,
                g = d.getTime() + 24 * e * 60 * 60 * 1e3;
            return Math.floor((c1.getTime() - g) / 864e5 / 7 + 1) + f
        }
    },
    TEXT: function (a, b) {
        return BsyUtils.isNull(a) ?
            "" : BsyUtils.isDate(a) && !BsyUtils.isEmpty(b) ?
                BsyUtils.date2Str(dayjsUtils.timeToTZ(a), b) : BsyUtils.num2Str(a, b)
    },
    VALUE: function (a) {
        return BsyUtils.isEmpty(a) ? 0 : isNaN(a) ? 0 : parseFloat(a)
    },
    UUID: function () {
        return BsyUtils.UUID()
    },
    RECNO: function () {
        let isSucess = false;
        let isFaild = false;
        if (BsyUtils.isNull(window.FX.STATIC.EntryRecNo)) {
            if (window.FX.STATIC.APPID && window.FX.STATIC.ENTRYID) {
                window.FX.Utils.dataAjax({
                    url: "/data/formula/recno",
                    async: !1,
                    data: {
                        appId: window.FX.STATIC.APPID,
                        formId: window.FX.STATIC.ENTRYID,
                        hasIncLock: window.FX.STATIC.RecnoLock
                    }
                }, function (a) {
                    isSucess = true;
                    window.FX.STATIC.EntryRecNo = a.incId
                }, function (e1) {
                    isFaild = true;
                    var code = e1.responseJSON.code;
                    var msg = e1.responseJSON.msg;
                    if (code === 3000 || code === 400) {
                        window.FX.STATIC['errorWidget' + window.FX.STATIC.APPID + window.FX.STATIC.ENTRYID] = msg;
                        var text = msg
                        // tipAlert({
                        //     type: "warning",
                        //     msg: text
                        // });
                    } else {
                        return !1
                    }
                    throw new customError(msg, "recno");

                }, (a) => {
                    if (!isSucess && !isFaild) {
                        throw new customError("status:" + a.status + " statusText:" + a.statusText, "recno");
                    }
                });
                return window.FX.STATIC.EntryRecNo;
            } else {
                return "";
            }
        } else {
            return window.FX.STATIC.EntryRecNo;
        }


        // return BsyUtils.isNull(window.FX.STATIC.EntryRecNo) ? window.FX.STATIC.APPID && window.FX.STATIC.ENTRYID ? (window.BsyUtils.dataAjax({
        //     url: "/data/formula/recno",
        //     async: !1,
        //     data: {
        //         appId: window.FX.STATIC.APPID,
        //         formId: window.FX.STATIC.ENTRYID,
        //         hasIncLock: window.FX.STATIC.RecnoLock
        //     }
        // }, function (a) {
        //     window.FX.STATIC.EntryRecNo = a.incId
        // }),
        //     window.FX.STATIC.EntryRecNo) : "" : window.FX.STATIC.EntryRecNo
    },
    ISEMPTY: function (a) {
        console.log('ISEMPTY: ', BsyUtils.isObjectEmpty(a))
        return BsyUtils.isObjectEmpty(a)
    },
    WEEKDAY: function (a) {
        var a1 = dayjsUtils.timeToTZ(a);
        if (!BsyUtils.isNull(a1)) {
            return a1.getDay();
        } 
        return null;
    },
    MAPX: function (a, b, c, d) {
        var e = null;
        if (BsyUtils.isEmpty(a) || BsyUtils.isObjectEmpty(b))
            return e;
        a = a.toLowerCase();
        var f = BsyUtils.getFieldInfoByFormula(c),
            g = BsyUtils.getFieldInfoByFormula(d);
        if (/^sum|avg|max|min|count|first|last$/.test(a) && f.entryId && f.entryId === g.entryId) {
            var h = BsyUtils.isDate(b),
                i = h ? b.getTime() : b;
            let isSucess = false;
            let isFaild = false;
            window.FX.Utils.dataAjax({
                url: "/data/formula/aggregate",
                async: !1,
                data: {
                    op: a,
                    formId: f.entryId,
                    lookup_value: i,
                    lookup_field: f.field,
                    result_field: g.field,
                    date_type: h,
                    refAppId: f.appId
                }
            }, function (a) {
                isSucess = true;
                a.result && a.result[0] && (e = a.result[0].result)
            }, function (e1) {
                isFaild = true;
                var code = e1.responseJSON.code;
                var msg = e1.responseJSON.msg;
                if (code === 3000 || code === 400) {
                    window.FX.STATIC['errorWidget' + window.FX.STATIC.APPID + window.FX.STATIC.ENTRYID] = msg;
                    var text = msg
                    // tipAlert({
                    //     type: "warning",
                    //     msg: text
                    // });
                } else {
                    return !1
                }
                throw new customError(msg, "mapx");
            }, (a) => {
                if (!isSucess && !isFaild) {
                    throw new customError("status:" + a.status + " statusText:" + a.statusText, "mapx");
                }
            })
        }
        return e
    },
    MAP: function (a, b, c) {
        var d = [];
        if (BsyUtils.isObjectEmpty(a))
            return d;
        var e = BsyUtils.getFieldInfoByFormula(b),
            f = BsyUtils.getFieldInfoByFormula(c);
        let isSucess = false;
        let isFaild = false;
        e.entryId && e.entryId === f.entryId && window.FX.Utils.dataAjax({
            url: "/data/formula/map",
            async: !1,
            data: {
                formId: e.entryId,
                lookup_value: a,
                lookup_field: e.field,
                result_field: f.field,
                refAppId: e.appId
            }
        }, function (a) {
            isSucess = true;
            BsyUtils.forEach(a.result, function (a, b) {
                d.push(b[f.field])
            })
        }, function (e1) {
            isFaild = true;
            var code = e1.responseJSON.code;
            var msg = e1.responseJSON.msg;
            if (code === 3000 || code === 400) {
                window.FX.STATIC['errorWidget' + window.FX.STATIC.APPID + window.FX.STATIC.ENTRYID] = msg;
                var text = msg
                // tipAlert({
                //     type: "warning",
                //     msg: text
                // });
            } else {
                return !1
            }
            throw new customError(msg, "map");
        }, (a) => {
            if (!isSucess && !isFaild) {
                throw new customError("status:" + a.status + " statusText:" + a.statusText, "map");
            }
        })
        return d
    },
    GETUSERNAME: function () {
        return window.FX.STATIC.user ? window.FX.STATIC.user.nickname : ""
    },
    IFS: function () {
        for (var t = null, e = 0; e < arguments.length; e += 2)
            if (arguments[e]) {
                var i = arguments[e + 1];
                t = BsyUtils.isNull(i) ? null : i;
                break
            }
        return t
    },
    ISNAN: function (a) {
        return a !== a
    },
    ISNULL: function (a) {
        return BsyUtils.ISNULL(a);
    },
    URLENCODE: function (a) {
        return encodeURIComponent(a);
    },
    URLDECODE: function (a) {
        return decodeURIComponent(a);
    },
    TEXT2ADDRESS: function (address) {

        if (BsyUtils.isString(address)) {
            if (BsyUtils.isObjectEmpty(address)) {
                return null;
            }
            let res = null
            window.FX.Utils.dataAjax({
                url: "/data/geocode",
                async: !1,
                data: {
                    address: address,
                    type: "geo",
                }
            }, function (result) {

                if (result.geocodes && result.geocodes.length > 0) {
                    res = {};
                    res.city = BsyUtils.isObjectEmpty(result.geocodes[0].city) ? undefined : result.geocodes[0].city;
                    const detail = [result.geocodes[0].township, result.geocodes[0].street, result.geocodes[0].streetNumber].join("");
                    res.detail = BsyUtils.isObjectEmpty(detail) ? undefined : detail;
                    res.district = BsyUtils.isObjectEmpty(result.geocodes[0].district) ? undefined : result.geocodes[0].district; //district
                    res.province = BsyUtils.isObjectEmpty(result.geocodes[0].province) ? undefined : result.geocodes[0].province;
                    if (['北京市', '天津市', '重庆市', '上海市'].indexOf(res.province) > -1) {
                        res.city = res.province;
                    }

                    if (result.geocodes[0].location && result.geocodes[0].location.indexOf(',') > -1) {
                        res.lnglatXY = result.geocodes[0].location.split(',');
                    }

                } else {
                    res = null;
                }

            }, function () {
                res = null;
            })
            return res;
        }
        return null;
    },
    LOCATION2ADDRESS: function (a) {
        var lnglat = null;
        if (BsyUtils.isString(a)) {
            if (BsyUtils.isObjectEmpty(a)) {
                return null;
            }
            lnglat = a.split(',');
            if (lnglat.length != 2) {
                return null;
            }
        } else if (BsyUtils.isArray(a)) {
            if (a.length != 2) {
                return null;
            }
            lnglat = a;
        }
        window.FX.Utils.dataAjax({
            url: "/data/geocode",
            async: !1,
            data: {
                location: lnglat.join(','),
                type: "regeo",
            }
        }, function (result) {

            if (result.status == "1" && result.info == "OK") {
                a = {};
                const addressComponent = result.regeocode.addressComponent;
                a.city = BsyUtils.isObjectEmpty(addressComponent.city) ? "" : addressComponent.city;
                const detail = [addressComponent.township,
                [
                    addressComponent.streetNumber.street,
                    addressComponent.streetNumber.number
                ].join("")
                ].join("");
                a.detail = BsyUtils.isObjectEmpty(detail) ? undefined : detail;
                a.district = BsyUtils.isObjectEmpty(addressComponent.district) ? "" : addressComponent.district;
                a.province = BsyUtils.isObjectEmpty(addressComponent.province) ? "" : addressComponent.province;

                if (['北京市', '天津市', '重庆市', '上海市'].indexOf(a.province) > -1) {
                    a.city = a.province;
                }
                a.lnglatXY = lnglat;
            } else {
                a = null;
            }

        }, function () {
            a = null;
        })
        return a;
    },
    ADDRESS2TEXT: function (a, format) {

        if (BsyUtils.isString(a)) {
            try {
                a = JSON.parse(a)
                if (a && a.hasOwnProperty('province')) {

                } else {
                    a = null;
                }
            } catch (e) {
                a = null;
            }
        } else {
            if (a && a.hasOwnProperty('province')) {

            } else {
                a = null;
            }
        }
        if (a) {
            format = format || 'pcda'
            switch (format) {
                case "p":
                case "pc":
                case "pcd":
                case "pcda": {
                    return BsyUtils.address2Str(a, format);
                }
                case "c": {
                    return a.city || '';
                }
                case "d": {
                    return a.district || '';
                }
                case "a": {
                    return a.detail || '';
                }
                case "lnglatXY": {
                    return !BsyUtils.isObjectEmpty(a.lnglatXY) ? a.lnglatXY.join(',') : ''
                }
                default: {
                    return BsyUtils.address2Str(a, 'pcda');
                }
            }
        }
        return null;
    },
    STR_MID: function (a, b, c) {
        a = (a || "") + '';
        if (BsyUtils.isNumber(b) && BsyUtils.isNumber(c)) {
            b = parseInt(b.toFixed(0));
            c = parseInt(c.toFixed(0));
            if (b == 0) return '';
            if (b > 0)
                return a.substr(b - 1, c)
            else {
                if (Math.abs(b) > a.length) {
                    return '';
                }
                return a.substr(b, c)
            }

        } else {
            return '';
        }

    },
    STR_RIGHT: function (a, b) {
        a = (a || "") + '';
        if (BsyUtils.isNumber(b)) {
            b = parseInt(b.toFixed(0));
            return a ? a.substring(a.length - b) : ''
        } else {
            return '';
        }
    },
    STR_REPLACE: function (a, b, c, d) {
        a = (a || "") + '';
        if (BsyUtils.isNumber(b) && BsyUtils.isNumber(c)) {
            b = parseInt(b.toFixed(0));
            if (b <= 0) {
                return a;
            }
            if (c <= 0) {
                return a.substr(0, b - 1) + d
            }
            c = parseInt(c.toFixed(0));
            a = a || ""
            d = d || ""
            return a.substr(0, b - 1) + d + a.substring(b + c - 1)
        } else {
            return a.replace(new RegExp(b, 'g'), c);
        }
    },
    STR_LEFT: function (a, b) {
        a = (a || "") + '';
        if (BsyUtils.isNumber(b)) {
            b = parseInt(b.toFixed(0));
            if (b == 0)
                return '';

            return a ? a.substring(0, b) : ''
        } else {
            return '';
        }
    },
    STR_REPT: function (a, b) {
        a = (a || "") + '';
        b = b || 0;
        b = parseInt(b.toFixed(0))
        return new Array(b + 1).join(a)
    },
    STR_VALUE: function (a) {
        a = (a || "") + '';
        let d = parseFloat(a);
        if (isNaN(d)) {
            return 0;
        }
        return d;
    },
    MATH_ROUND: function (a, b) {
        let d = parseFloat(a);
        if (isNaN(d)) {
            return 0;
        }
        b = b || 0;
        b = parseFloat(b.toFixed(0));
        if (b <= 0) {
            return 0;
        }
        if (b >= 100) {
            return a;
        }
        return parseFloat(d.toFixed(b));
    },
    MATH_SQRT: function (a) {
        return a < 0 ? null : Math.sqrt(a)
    },

    STR_SPLIT: function (str, sep, num) {
        if (!BsyUtils.isString(str) || !str) {
            return '';
        }
        if (!BsyUtils.isString(sep) || !sep) {
            return '';
        }
        var n = parseFloat(num)
        if (isNaN(n)) {
            return '';
        }
        num = Math.round(n);
        var strs = str.split(sep);
        var res = '';
        if (num >= 0) {
            for (var i = 0; i < num; i++) {
                if (strs.length >= i + 1) {
                    if (i == 0) {
                        res = strs[i];
                    } else {
                        res += sep + strs[i];
                    }
                }
            }
        } else {

            let start = strs.length + num
            if (start < 0) {
                start = 0;
            }
            let index = 0;
            for (var i = start; i < strs.length; i++) {
                if (strs.length >= i + 1) {

                    if (index == 0) {
                        res = strs[i];
                    } else {
                        res += sep + strs[i];
                    }
                    index++;
                }
            }
        }
        return res;
    },
    UNION: function () {
        for (var t = {}, e = arguments.length, r = new Array(e), n = 0; n < e; n++)
            r[n] = arguments[n];
        var o = BsyUtils.flatten(r, (function (e) {
            var r = (BsyUtils.isString(e) || BsyUtils.isNumber(e)) && !BsyUtils.isObjectEmpty(e);
            return r && (e = String(e),
                t[e] ? r = !1 : t[e] = !0),
                r
        }
        ))
            , i = [];
        _.map(o, (function (t) {
            i.push(String(t))
        }
        ))
        return i
    },
    JOIN: function (t, e) {
        return BsyUtils.isArray(t) && BsyUtils.isString(e) ? t.join(e) : ""
    },
    RADIANS: function (t) {
        return t = BsyUtils.parseNumber(t),
            _.isNil(t) ? null : t * Math.PI / 180
    },
    SIN: function (t) {
        return t = BsyUtils.parseNumber(t),
            _.isNil(t) ? null : BsyUtils.fixDecimalPrecision(Math.sin(t))
    }
    ,
    COS: function (t) {
        return t = BsyUtils.parseNumber(t),
            _.isNil(t) ? null : BsyUtils.fixDecimalPrecision(Math.cos(t))
    }
    ,
    TAN: function (t) {
        return t = BsyUtils.parseNumber(t),
            _.isNil(t) ? null : BsyUtils.fixDecimalPrecision(Math.tan(t))
    }
    ,
    COT: function (t) {
        if (t = BsyUtils.parseNumber(t),
            _.isNil(t))
            return null;
        var e = Math.tan(t);
        return 0 === BsyUtils.fixDecimalPrecision(e) ? null : BsyUtils.fixDecimalPrecision(1 / e)
    },
    SUMIF: function (t, e) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t
            , n = BsyUtils.makeArray(t)
            , o = BsyUtils.makeArray(r);
        if (n.length !== o.length)
            return null;
        if (_.isNil(e) || "" === e)
            return 0;
        var i = 0;
        _.map(n, (function (t, r) {
            var n = o[r];
            BsyUtils.isNumber(n) && BsyUtils.compareOp(t, e) && (i += BsyUtils.parseNumber(n))
        }
        ))
        return i
    },
    SUMIFS: function (t) {
        for (var e = BsyUtils.makeArray(t), r = Math.min(arguments.length <= 1 ? 0 : arguments.length - 1, 254), n = 0, o = 0; o < e.length; o++) {
            var i = !1
                , a = e[o];
            if (BsyUtils.isNumber(a)) {
                for (var s = 0; s < r; s += 2) {
                    var c = BsyUtils.makeArray(s + 1 < 1 || arguments.length <= s + 1 ? void 0 : arguments[s + 1]);
                    if (c.length !== e.length)
                        return null;
                    var u = s + 1 + 1 < 1 || arguments.length <= s + 1 + 1 ? void 0 : arguments[s + 1 + 1];
                    if (_.isNil(u) || "" === u)
                        return 0;
                    var l = c[o];
                    if (!(i = BsyUtils.compareOp(l, u)))
                        break
                }
                i && (n += BsyUtils.parseNumber(a))
            }
        }
        return n
    },
    NETWORKDAYS: function (t, r, n) {
        t = BsyUtils.filterDate(t);
        r = BsyUtils.filterDate(r);
        if (_.isNil(t) || _.isNil(r))
            return null;
        let o = !1;
        if (dayjsUtils.isBefore(r, t, "date")) {
            o = !0;
            let i = t;
            t = r;
            r = i;
        }
        var a = dayjsUtils.getDay(t)
            , s = BsyUtils.getDays(t)
            , c = dayjsUtils.getDay(r)
            , u = BsyUtils.getDays(r)
            , l = (u - s - (c - a)) / 7 * 5;
        l += c - a + 1;
        0 === a && l--;
        6 === c && l--;
        let p = BsyUtils.getFormatHolidays(n, !1, null /*timezone*/);
        _.map(p, (function (t) {
            let e = BsyUtils.getDays(t);
            if (e >= s && e <= u) {
                let r = dayjsUtils.getDay(t);
                6 !== r && 0 !== r && l--
            }
        }
        ));
        o && (l = BsyUtils.parseNumber(-l));
        return l;
    },
    WORKDAY: function (t, r, n) {
        t = BsyUtils.filterDate(t)
        if (_.isNil(t))
            return null;
        if (!(r = BsyUtils.parseNumber(r)) || Math.abs(r) > 1e5)
            return dayjsUtils.toDate(t);
        r = r > 0 ? Math.ceil(r) : Math.floor(r);
        let o = dayjsUtils.getDay(t)
            , i = BsyUtils.getDays(t)
            , a = 0;
        a += r > 0 ? BsyUtils.getDaysWithForward({
            startDay: i,
            startWeekNo: o,
            workdays: r,
            holidays: n,
            timezone: undefined//e.context.timezone
        }) : BsyUtils.getDaysWithBackwards({
            endDay: i,
            endWeekNo: o,
            workdays: r,
            holidays: n,
            timezone: undefined
        });
        return dayjsUtils.toDate(dayjsUtils.addDate(t, a))
    },
    DISTANCE: function (t, e) {
        let r, n;
        try {
            let o, i, a = /^\d+(\.\d+)?,\d+(\.\d+)?$/;
            r = a.test(t) ? t.split(",") : JSON.parse(t).lnglatXY;
            n = a.test(e) ? e.split(",") : JSON.parse(e).lnglatXY;
        } catch (t) {
            return null
        }
        if (BsyUtils.isObjectEmpty(r) || BsyUtils.isObjectEmpty(n))
            return null;
        var s = r[0];
        var c = n[0];
        var u = r[1];
        var l = n[1];
        var p = .017453292519943295;
        var f = Math.cos;
        var h = .5 - f((l - u) * p) / 2 + f(u * p) * f(l * p) * (1 - f((c - s) * p)) / 2;
        var y = 12756274 * Math.asin(Math.sqrt(h));
        var d = BsyUtils.fixDecimalPrecision(y, 2);
        return BsyUtils.isValidNumber(d) ? d : null
    },
    FX_INDEX: function (t, e) {
        if (BsyUtils.isArray(t) && BsyUtils.isNumber(e))
            if (e > 0) {
                if (t.length >= e)
                    return t[e - 1]
            } else if (e < 0 && t.length >= Math.abs(e))
                return t[t.length + e];
        return null
    },
    INDEX: function (t, e) {
        if (BsyUtils.isArray(t) && BsyUtils.isNumber(e))
            if (e > 0) {
                if (t.length >= e)
                    return t[e - 1]
            } else if (e < 0 && t.length >= Math.abs(e))
                return t[t.length + e];
        return null
    },
};
